import { render, staticRenderFns } from "./customOrder.vue?vue&type=template&id=0840a048&"
import script from "./customOrder.vue?vue&type=script&lang=js&"
export * from "./customOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/customOrder.vue"
export default component.exports